import type { FaireProductEntity } from "../../entity_types/product";

export const p_netyctvwwf: FaireProductEntity = {
  token: "p_netyctvwwf",
  type: "product",
  name: "Ora Cacao Cups",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/b027bbe3bbae0e5a4d4ed526e01c9665a47fa5458676f1c8b9b77825aa57924f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b12308233dda0321faf3b18e6a0e9daddb998abafa228d5724520281c725a3a8.jpeg",
    "https://cdn.faire.com/fastly/84a3bceaf6dd45b70543224825b7f26908e63d71d7573932194dd5a0a30122dc.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "We’re super excited about these perfect cacao cups because they're:\n\n• Made from sustainably harvested wood\n• Laser engraved with the Ora Logo\n• The perfect size for a 6oz cup of cacao\n• Pretty hard to destroy which is perfect for traveling! We tested the durability by dropping a cup from 6ft in the air multiple times.\n• Easy to clean, although we do recommend hand washing instead of the dishwasher.\n• Affordable enough to get a set if you’re sharing in cacao ritual with others\n• The smooth curves feel good to hold!",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:44.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
